import TermsOfServiceContent from "./TermsOfService"
export default TermsOfServiceContent
